import script from "./PhoneOtp.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneOtp.vue?vue&type=script&setup=true&lang=js"

import "./PhoneOtp.vue?vue&type=style&index=0&id=3d4e4af0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4e4af0"]])

export default __exports__